import { LayerProps } from "react-map-gl";

export type MapSourceData = {
  sourceLayer?: LayerProps;
  getSourceData?: Function;
  sourceTileUrl?: string; // for raster
  sourceData: GeoJsonData | string; // GeoJsonData or URL string where applicable
  layerId?: string;
  sourceId?: string;
};

export const defaultLayer: LayerProps = { id: "defaultLayer", type: "fill", paint: {} };

export const emptyGeojson: GeoJsonData = {
  type: "FeatureCollection",
  features: [],
};

export const defaultSourceLayer = {
  sourceLayer: defaultLayer,
  sourceData: emptyGeojson,
} as MapSourceData;
